export const SECTIONS = {
  SECTION_1: 'section_1',
  SECTION_2: 'section_2'
};
